'use strict';

/* global $ */

function Faqs (options) {
    var opt = $.extend({
        selector: '.js-faqs-item',
        answer: '.js-faqs-answer',
        more: '.js-faqs-more',
        duration: 600
    }, options);

    function InitBlock(el) {
        let $item = $(el),
            $answer = $item.find(opt.answer),
            $more = $item.find(opt.more);

        let answerHeight,
            isToggle = false;

        let moreUp = $more.data('up');
        let moreDown = $more.data('down');

        function resize() {
            answerHeight = $answer.get(0).scrollHeight;
            if (answerHeight > 95) {
                $answer.css({
                    maxHeight: '95px'

                });
                $more.css({
                    display: 'inline-block'
                })
                isToggle = false;
                $more.text(moreDown);
            } else {
                $answer.css({
                    maxHeight: ''
                });
                $more.css({
                    display: 'none'
                })
            }
        }

        $more.click(function() {
            if (isToggle == false) {
                $answer.css({
                    maxHeight: '100%'
                });
                isToggle = true;
                $more.text(moreUp);
            } else {
                $answer.css({
                    maxHeight: '95px'
                });
                isToggle = false;
                $more.text(moreDown);
            }
        });

        $(window).resize(resize);
        resize();
    }

    $(opt.selector).each(function() {
        InitBlock(this);
    });
}


export {
    Faqs
};

